import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TipiAltroSoggettoFormComponent } from './dialogs/form/form.component';
import { TipiAltroSoggettoRoutingModule } from './tipi-altro-soggetto-routing.module';
import { TipiAltroSoggettoComponent } from './tipi-altro-soggetto.component';
import { CustomMaterialModule } from '../../material-module/material.module';
import { ResourcefulIndexModule } from '../../shared/resourceful-index/resourceful-index.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';

@NgModule({
  declarations: [TipiAltroSoggettoComponent, TipiAltroSoggettoFormComponent],
  imports: [
    CommonModule,
    TipiAltroSoggettoRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CustomMaterialModule,
    ResourcefulIndexModule,
    CustomFormControlsModule,
  ]
})
export class TipiAltroSoggettoModule { }
